import React from 'react'
import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'

const PrivateLayout = ({ children }) => {
  const router = useRouter()

  const { user, checked } = useSelector(state => ({
    user: state.auth.user,
    checked: state.auth.checked,
  }))

  if (!checked) {return null}

  if (typeof window !== 'undefined' && !user) {
    if (router.pathname.startsWith('/dashboard')) {
      router.replace(`/dashboard/login?redirect=${encodeURIComponent(router.asPath)}`)
    } else {
      router.replace('/')
    }
    return null
  }

  return (
    <>
      {children}
    </>
  )
}

PrivateLayout.propTypes = {
  children: PropTypes.node,
}

export default PrivateLayout
